import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { FIELD__base } from '../FIELD__base';
import { FN_FIELD_CONTAINER__get_fields } from './FN_FIELD_CONTAINER__get_fields';
import { FN_FIELD_CONTAINER__get_metadata_map } from './FN_FIELD_CONTAINER__get_metadata_map';

export function FN_FIELD_CONTAINER__init_as_default(target: any) {
  const fields_meta_map = FN_FIELD_CONTAINER__get_metadata_map(target);

  for (const [field_name, field_meta] of Object.entries(fields_meta_map)) {
    // Create the new default field instance
    let field_new: FIELD__base = field_meta.class_object.create_field_container_default(field_meta.options_field);

    // Get the current value from the target instance
    let field_existing = target[field_name];

    assert_instanceof(field_existing, FIELD__base);

    // If it's not a stub (already has data), merge/clone it into the new default
    if (!field_existing.is_stub()) field_new = field_existing.clone(field_new);

    // Apply the metadata options to the field's internal meta object
    field_new.meta = field_new.meta.clone(field_meta.options_meta);

    //recreate id
    field_new.id_create();

    let field_children = FN_FIELD_CONTAINER__get_fields(field_new);
    for (let field_child of field_children) {
      field_child.copy_meta_from_parent(field_new);

      if (field_new.meta.data__is_linked) {
        field_child.meta.data__is_linked = true;
        field_child.meta.data__synced_by_parent_id = field_new.meta.field_id;
      }
    }

    // Re-assign the processed field back to the target instance
    target[field_name] = field_new;
  }
}

export function FN_FIELD_CONTAINER__init_as_default_backup(target: any, force_create_default = false) {
  const fields_meta_map = FN_FIELD_CONTAINER__get_metadata_map(target);

  for (const [field_name, field_meta] of Object.entries(fields_meta_map)) {
    // Create the new default field instance
    let field_new: FIELD__base;

    if (force_create_default || !field_meta.options_meta.data__is_required) {
      field_new = field_meta.class_object.create_field_container_default(field_meta.options_field);
    } else {
      field_new = field_meta.class_object.create_field_container_stub();
    }

    // Get the current value from the target instance
    let field_existing = target[field_name];

    assert_instanceof(field_existing, FIELD__base);

    // If it's not a stub (already has data), merge/clone it into the new default
    if (!field_existing.is_stub()) field_new = field_existing.clone(field_new);

    // Apply the metadata options to the field's internal meta object
    field_new.meta = field_new.meta.clone(field_meta.options_meta);

    //recreate id
    field_new.id_create();

    let field_children = FN_FIELD_CONTAINER__get_fields(field_new);
    for (let field_child of field_children) field_child.copy_meta_from_parent(field_new);

    // Re-assign the processed field back to the target instance
    target[field_name] = field_new;
  }
}
